<ng-template [sbmodal]="'inventorySelectionModal'">
  <sb-custom-modal [templateId]="'inventorySelectionModal'">
    <div slot="body">
      <sb-page-inventory-wrapper [isInModalContext]="true"></sb-page-inventory-wrapper>
    </div>
  </sb-custom-modal>
</ng-template>
<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <ng-template #tab1Headline>
          <ng-container *ngIf="campaignData?.name">
            <table style="font-size: .9rem;">
              <tr class="font-weight-bold my-2">
                <td>
                  <span [innerHTML]="campaignData?.name | truncate : 20"></span>
                </td>
              </tr>
            </table>
          </ng-container>
        </ng-template>
        <sb-wizard #wizard classes="wizard__minHeightSetting">
          <sb-wizard-tab #tab1 titleText="{{ 'lang.wizard.tabs.settings' | translate }}" icon="basicSettings"
                         [disabled]="wizardState!=='Map'" [headlineTemplate]="tab1Headline">
            <form [formGroup]="form" class="wizard__forms px-5">
              <h3 class="mb-4">{{ 'lang.globals.relatedCompany' | translate }}</h3>
              <div class="wizard__forms__filterWrapper">
                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('Company')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter"
                  >
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : customer}" icon="company"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="customer?.name">{{ customer?.name }}</h3>
                      <label class="form-label">{{ 'lang.globals.customer' | translate }}<span class="red"
                                                                                               *ngIf="!customer">*</span></label>
                    </div>

                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button *ngIf="!campaignData?.id" (click)="changeWizardState('CompanySelect')"
                                 ngbTooltip="{{'lang.globals.selectCompany' | translate}}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='CompanySelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span *ngIf="!campaignData?.id" class="btn-separator">|</span>
                      <sb-button *ngIf="!campaignData?.id" (click)="changeWizardState('CompanyCreate')"
                                 ngbTooltip="{{'lang.companies.createCompany' | translate}}" placement="top"
                                 container="body"
                                 style="z-index: 10000;"
                                 classes="btn btn-hover-primary m-0 green {{wizardState==='CompanyCreate' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <span *ngIf="customer &&!campaignData?.id" class="btn-separator">|</span>
                      <sb-button *ngIf="customer && !campaignData?.id" (click)="sliceCompany()"
                                 ngbTooltip="{{'lang.globals.removeCompany' | translate}}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 red">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>
              </div>
              <h3 class="mb-4">{{ 'lang.campaignEdit.settingsHeadline' | translate }}</h3>
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group validateMe">
                    <label for="Title" class="form-label">{{ 'lang.globals.title' | translate }}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Title"
                           sbAutofocus required>
                    <span class="form-text text-muted position-relative">{{ 'lang.campaignEdit.titleDescription' | translate }}</span>
                    <div *ngIf="Title.touched && Title.errors?.required" class="alert alert-danger">
                      {{ 'lang.campaignEdit.titleWarning' | translate }}
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label for="Identifier" class="form-label">{{ 'lang.globals.identifier' | translate }}</label>
                    <input type="text" id="Identifier" class="form-control" formControlName="Identifier">
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label for="CampaignId" class="form-label">{{ 'lang.globals.campaignId' | translate }}</label>
                    <input type="text" id="CampaignId" class="form-control" formControlName="CampaignId">
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group validateMe d-block">
                    <label for="Level" class="form-label">
                      {{ 'lang.globals.level' | translate }}<span class="red">*</span>
                    </label>
                    <div class="d-flex">
                      <select id="Level" required
                              class="form-select mr-2" formControlName="Level">
                        <option *ngFor="let option of levelOptions" [ngValue]="option">
                          {{ option.id.level + ' "' + option.name + '"' }}
                        </option>
                      </select>
                      <button [disabled]="!customer" (click)="showEditLevel()" container="body"
                              class="btn btn-hover-primary " ngbTooltip="{{'lang.globals.createNewLevel' | translate}}"
                              placement="top">
                        <sb-icon icon="level"></sb-icon>
                      </button>
                    </div>
                    <span class="form-text text-muted">{{ 'lang.globals.campaignLevelDescription' | translate }}</span>
                    <div *ngIf="Level.touched && Level.errors?.required" class="alert alert-danger">
                      {{ 'lang.globals.levelWarning' | translate }}
                    </div>
                  </div>
                </div>


                <div class="col-md-6">
                  <label for="CampaignType" class="form-label">{{ 'lang.globals.campaignType' | translate }}</label>
                  <button (click)="selectCampaignType()"
                          [disabled]="!customer || !permissionService.hasPermission(permissionService.Permission.campaign_type_list)"
                          type="button"
                          id="CampaignType"
                          class="btn btn-secondary w-100">
                    <sb-icon class="mr-1" icon="megaphoneTypes"></sb-icon>
                    {{ campaignTypeText }}
                  </button>
                </div>
              </div>
              <div class="wizard__footerActions mb-3">
                <button type="button" (click)="util.returnToNavigation(util.RoutingID.campaigns)"
                        class="btn btn-default btn-wizard">{{ 'lang.globals.cancel' | translate }}
                </button>
                <button type="button" (click)="nextStep(wizard, tab2);isCompanyEditable =false" class="btn btn-primary btn-wizard"
                        [disabled]="!form.valid">{{ 'lang.globals.next' | translate }}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
          <sb-wizard-tab #tab2 titleText="{{ 'lang.wizard.tabs.selection' | translate }}" icon="selection"
                         [disabled]="wizardState!=='Map'">
            <div class="wizard__forms px-5 pt-2">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <h3>{{ 'lang.campaignEdit.selectionHeadline' | translate }} </h3>
                <h6>
                  <sb-icon icon="location"></sb-icon>
                  {{ previewCampaignData?.playerAggregation?.locations | sbNumberFormat }}
                  {{ 'lang.globals.locations' | translate }} /
                  <sb-icon icon="screen"></sb-icon>
                  {{ previewCampaignData?.playerAggregation?.screens | sbNumberFormat }}
                  {{ 'lang.globals.player' | translate }}
                </h6>
              </div>
              <div *ngPermissions="[permissionService.Permission.cull_show]" class="wizard__forms__filterWrapper">
                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    class="wizard__forms__filterWrapper__filterStep__singleFilter wizard__forms__filterWrapper__filterStep__singleFilter__headline">
                    <h6>{{ 'lang.campaignEdit.subheadline' | translate }}</h6>
                  </div>
                </div>
                <div class="wizard__forms__filterWrapper__filterStep">
                  <!--                  <div class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <fa-icon icon="calendar"></fa-icon>
                    </div>
                  </div>-->
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('TimeCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : campaignData?.timeCull}" icon="calendar"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="campaignData?.timeCull?.name">{{ campaignData?.timeCull?.name }}</h3>
                      <label class="form-label">{{ 'lang.globals.timeFilter' | translate }}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button *ngPermissions="[permissionService.Permission.cull_list]"
                                 (click)="changeWizardState('TimeCullSelect')"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate}}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='TimeCullSelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        *ngIf="!campaignData?.timeCull && permissionService.hasPermissions([permissionService.Permission.cull_time_create])"
                        (click)="changeWizardState('TimeCullEdit')"
                        ngbTooltip="{{'lang.globals.createFilter' | translate}}" placement="top" container="body"
                        classes="btn-hover-primary m-0 green {{wizardState==='TimeCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <sb-button
                        *ngIf="campaignData?.timeCull && !campaignData?.timeCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_time_edit])"
                        (click)="changeWizardState('TimeCullEdit')"
                        ngbTooltip="{{'lang.globals.editSelectedFilter' | translate}}" placement="top" container="body"
                        classes="btn-hover-primary {{wizardState==='TimeCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button *ngIf="campaignData?.timeCull" (click)="sliceCull($event, 'TimeCull')"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate}}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 red">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('PlayerCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : campaignData?.playerCull}" icon="playerOnline"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="campaignData?.playerCull?.name">{{ campaignData?.playerCull?.name }}</h3>
                      <label class="form-label">{{ 'lang.globals.playerFilter' | translate }}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button *ngPermissions="[permissionService.Permission.cull_list]"
                                 (click)="changeWizardState('PlayerCullSelect')"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate}}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='PlayerCullSelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator" *ngIf="!campaignData?.playerCull">|</span>
                      <sb-button
                        *ngIf="!campaignData?.playerCull && permissionService.hasPermissions([permissionService.Permission.cull_player_create])"
                        (click)="changeWizardState('PlayerCullEdit')"
                        ngbTooltip="{{'lang.globals.createFilter' | translate}}" placement="top" container="body"
                        classes="btn-hover-primary m-0 green {{wizardState==='PlayerCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        *ngIf="!campaignData?.playerCull && permissionService.hasPermissions([permissionService.Permission.cull_player_create])"
                        (click)="openInventoryView()" ngbTooltip="{{'lang.globals.selectScreens' | translate}}"
                        container="body"
                        placement="top"
                        classes="btn-hover-primary m-0 green">
                        <sb-icon icon="checkList"></sb-icon>
                      </sb-button>
                      <sb-button
                        *ngIf="campaignData?.playerCull && !campaignData?.playerCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_player_edit])"
                        (click)="changeWizardState('PlayerCullEdit')"
                        ngbTooltip="{{'lang.globals.editSelectedFilter' | translate}}" placement="top" container="body"
                        classes="btn-hover-primary {{wizardState==='PlayerCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button *ngIf="campaignData?.playerCull" (click)="sliceCull($event, 'PlayerCull')"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate}}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 red">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>

                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('GeoCull')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : campaignData?.geoCull}" icon="globe"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="campaignData?.geoCull?.name">{{ campaignData?.geoCull?.name }}</h3>
                      <label class="form-label">{{ 'lang.globals.geoFilter' | translate }}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button *ngPermissions="[permissionService.Permission.cull_list]"
                                 (click)="changeWizardState('GeoCullSelect')"
                                 ngbTooltip="{{'lang.globals.selectFilter' | translate}}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='GeoCullSelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button
                        *ngIf="!campaignData?.geoCull && permissionService.hasPermissions([permissionService.Permission.cull_geo_create])"
                        (click)="changeWizardState('GeoCullEdit')"
                        ngbTooltip="{{'lang.globals.createFilter' | translate}}" placement="top" container="body"
                        classes="btn-hover-primary m-0 green {{wizardState==='GeoCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <sb-button
                        *ngIf="campaignData?.geoCull && !campaignData?.geoCull?.global && permissionService.hasPermissions([permissionService.Permission.cull_geo_edit])"
                        (click)="changeWizardState('GeoCullEdit')"
                        ngbTooltip="{{'lang.globals.editSelectedFilter' | translate}}" placement="top" container="body"
                        classes="btn-hover-primary {{wizardState==='GeoCullEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="edit"></sb-icon>
                      </sb-button>
                      <sb-button *ngIf="campaignData?.geoCull" (click)="sliceCull($event, 'GeoCull')"
                                 ngbTooltip="{{'lang.globals.removeFilterFromSelection' | translate}}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 red">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard__footerActions">
                <button type="button" [disabled]="wizardState!=='Map'"
                        ngbTooltip="{{wizardState!=='Map' ? ('lang.globals.exitFilterMode' | translate) : ''}}"
                        placement="top" container="body"
                        (click)="nextStep(wizard, tab1);isCompanyEditable = true"
                        class="btn btn-default btn-wizard">{{ 'lang.globals.previous' | translate }}
                </button>
                <button [disabled]="wizardState!=='Map'" type="button"
                        ngbTooltip="{{wizardState!=='Map' ? ('lang.globals.exitFilterMode' | translate) : ''}}"
                        placement="top" container="body"
                        (click)="nextStep(wizard, tab3)" class="btn btn-primary btn-wizard">
                  {{ 'lang.globals.next' | translate }}
                </button>
              </div>
            </div>
          </sb-wizard-tab>
          <sb-wizard-tab #tab3 titleText="{{ 'lang.wizard.tabs.targetingAndBudget' | translate }}" icon="budget"
                         [disabled]="wizardState!=='Map'">
            <div class="wizard__forms px-5">
              <div *ngPermissions="[permissionService.Permission.targeting_show]" class="wizard__forms__filterWrapper">
                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('TargetingSelect')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : campaignData?.targeting}" icon="targeting"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="campaignData?.targeting?.name">{{ campaignData?.targeting?.name }}</h3>
                      <label class="form-label">{{ 'lang.globals.targeting' | translate }}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button *ngPermissions="[permissionService.Permission.targeting_list]"
                                 (click)="changeWizardState('TargetingSelect')"
                                 ngbTooltip="{{'lang.globals.targeting' | translate}}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='TargetingSelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span class="btn-separator" *ngIf="!campaignData?.targeting">|</span>
                      <sb-button
                        *ngIf="!campaignData?.targeting && permissionService.hasPermissions([permissionService.Permission.targeting_create])"
                        (click)="createTargeting();changeWizardState('TargetingCreate')"
                        ngbTooltip="{{'nav.network.targeting.create' | translate}}" placement="top" container="body"
                        classes="btn-hover-primary m-0 green {{wizardState==='TargetingEdit' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <span *ngIf="campaignData?.targeting" class="btn-separator">|</span>
                      <sb-button *ngIf="campaignData?.targeting" (click)="sliceTargeting()"
                                 ngbTooltip="{{'lang.globals.delete' | translate}}" placement="top"
                                 container="body"
                                 classes="btn-hover-primary m-0 red">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="border-dashed mb-5">
              <div class="d-flex justify-content-between align-items-center mb-4">
                <form [formGroup]="formBudget" class="wizard__forms w-100">
                  <div class="d-flex justify-content-between align-items-center mb-4">
                    <h3>{{ 'lang.campaignEdit.budget' | translate }} </h3>
                    <div class="form-check form-switch mr-3 timingActive">
                      <input type="checkbox" role="switch" class="form-check-input" id="EnableCampaignBudgetToggle"
                             formControlName="EnableCampaignBudgetToggle">
                      <label class="form-check-label"
                             for="EnableCampaignBudgetToggle">{{ 'lang.globals.active' | translate }}</label>
                    </div>
                  </div>
                  <div *ngIf="campaignData?.budget"><!--[@slideInOut] -->
                    <div class="row">
                      <div class="col-xl-6">
                        <div class="form-group validateMe">
                          <label class="form-label" for="BudgetAmount">{{ 'lang.budget.amount' | translate }}</label>
                          <div class="input-group">
                            <input type="number" id="BudgetAmount" class="form-control text-end"
                                   formControlName="Amount">
                            <div class="input-group-append">
                              <span class="input-group-text h-100">{{ BudgetCurrency?.value?.symbol }}</span>
                            </div>
                          </div>
                          <span class="form-text text-muted">{{ 'lang.budget.amount.description' | translate }}</span>
                        </div>
                      </div>
                      <div class="col-xl-3">
                        <div class="form-group validateMe">
                          <label class="form-label" for="BudgetCurrency">{{ 'lang.budget.currency' | translate }}</label>
                          <select id="BudgetCurrency" class="form-control" formControlName="Currency">
                            <option *ngFor="let currency of util.currencies" [value]="currency">{{ currency.name }}
                              ({{ currency.symbol }})
                            </option>
                          </select>
                          <span class="form-text text-muted">{{ 'lang.budget.currency.description' | translate }}</span>
                        </div>
                      </div>
                      <div class="col-xl-3">
                        <div class="form-group validateMe">
                          <label class="form-label" for="BudgetRelation">{{ 'lang.budget.relation' | translate }}</label>
                          <select id="BudgetRelation" class="form-control" formControlName="Relation">
                            <option *ngFor="let relation of timingRelations" [value]="relation">
                              {{ 'lang.targetingAndBudget.timingRelations.' + relation | translate }}
                            </option>
                          </select>
                          <span class="form-text text-muted">{{ 'lang.budget.relation.description' | translate }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xl-4">
                        <div class="form-group validateMe">
                          <label class="form-label" for="BudgetMaxCPM">{{ 'lang.budget.maxCPM' | translate }}</label>
                          <div class="input-group">
                            <input type="number" id="BudgetMaxCPM" class="form-control text-end"
                                   formControlName="MaxCPM" />
                            <div class="input-group-append">
                              <span class="input-group-text h-100">{{ BudgetCurrency?.value?.symbol }}</span>
                            </div>
                          </div>
                          <span class="form-text text-muted">{{ 'lang.budget.maxCPM.description' | translate }}</span>
                        </div>
                      </div>
                      <div class="col-xl-4">
                        <div class="form-group validateMe">
                          <label class="form-label" for="BudgetMaxCPMDuration">{{ 'lang.budget.maxCPMDuration' | translate }}</label>
                          <div class="input-group">
                            <input type="number" id="BudgetMaxCPMDuration" class="form-control text-end"
                                   formControlName="MaxCPMDuration" />
                            <div class="input-group-append">
                              <span class="input-group-text h-100">s</span>
                            </div>
                          </div>
                          <span
                            class="form-text text-muted">{{ 'lang.budget.maxCPMDuration.description' | translate }}</span>
                        </div>
                      </div>
                      <div class="col-xl-4">
                        <div class="form-group validateMe">
                          <label class="form-label" for="BudgetMaxCPS">{{ 'lang.budget.maxCPS' | translate }}</label>
                          <div class="input-group">
                            <input type="number" id="BudgetMaxCPS" class="form-control text-end"
                                   formControlName="MaxCPS" />
                            <div class="input-group-append">
                              <span class="input-group-text h-100">{{ BudgetCurrency?.value?.symbol }}</span>
                            </div>
                          </div>
                          <span class="form-text text-muted">{{ 'lang.budget.maxCPS.description' | translate }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div class="wizard__footerActions mb-3">
                <button type="button" [disabled]="wizardState!=='Map'"
                        ngbTooltip="{{wizardState!=='Map' ? ('lang.globals.exitFilterMode' | translate) : ''}}"
                        placement="top" container="body"
                        (click)="nextStep(wizard, tab2)"
                        class="btn btn-default btn-wizard">{{ 'lang.globals.previous' | translate }}
                </button>
                <button [disabled]="getSubmissionStatus() || loading" type="button"
                        ngbTooltip="{{wizardState!=='Map' ? ('lang.globals.exitFilterMode' | translate) : ''}}"
                        placement="top" container="body"
                        (click)="createAndUpdateCampaign()" class="btn btn-success btn-wizard">
                  {{ 'lang.globals.submit' | translate }}
                </button>
              </div>
            </div>
          </sb-wizard-tab>

          <div
            class="wizard__aside wizard__aside--half wizard__aside--right p-0 flex-column wizardFilterBG">
            <div *ngIf="wizardState!=='Map'" class="w-100 d-flex px-4 pt-4 justify-content-end">
              <button (click)="changeWizardState('Map')" class="btn btn-hover-primary d-flex align-items-center">
                <sb-icon icon="cancel" class="icon-in-btn mr-1"></sb-icon>
                {{ 'lang.globals.closeFilterSelection' | translate }}
              </button>
            </div>

            <div *ngIf="wizardState!=='Map'" #filterSelection class="w-100 p-4">
              <filter-edit class="w-100 p-4" *ngIf="wizardState==='TimeCullEdit'" [isInSidebarContext]=true
                           [cullId]="campaignData?.timeCull?.id" [type]="'TimeCull'"
                           (submitSuccess)="filterSubmitSuccess($event)">
              </filter-edit>

              <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                   *ngIf="wizardState==='TimeCullSelect'"
                                   preselectType="TimeCull" [preselectedCompany]="customer"
                                   (selectedFilter)="selectFilter($event)"></sb-page-filter-list>

              <filter-edit class="w-100 p-4" *ngIf="wizardState==='PlayerCullEdit'" [isInSidebarContext]=true
                           [cullId]="campaignData?.playerCull?.id" [type]="'PlayerCull'"
                           (submitSuccess)="filterSubmitSuccess($event)"></filter-edit>

              <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                   *ngIf="wizardState==='PlayerCullSelect'"
                                   preselectType="PlayerCull" [preselectedCompany]="customer"
                                   (selectedFilter)="selectFilter($event)"></sb-page-filter-list>

              <sb-page-companies class="w-100 p-4" *ngIf="wizardState==='CompanySelect'"
                                 (selectedCompany)="selectCompany($event)" [toggleContext]="'hasCampaigns'"
                                 [isInIntegratedContext]="true"></sb-page-companies>

              <sb-page-company-edit class="w-100 p-4" *ngIf="wizardState==='CompanyCreate'"
                                    (companyEmitter)="createCompany($event)"
                                    [isInIntegratedContext]="true"></sb-page-company-edit>

              <sb-page-targeting class="w-100 p-4" *ngIf="wizardState==='TargetingSelect'"
                                 (targetingSelected)="selectTargeting($event)"
                                 [isInIntegratedContext]="true"></sb-page-targeting>

              <sb-page-targeting-edit class="w-100 p-4" *ngIf="wizardState==='TargetingCreate'"
                                      (editTargeting)="addTargeting($event)"
                                      [targeting]="campaignData.targeting"></sb-page-targeting-edit>

              <filter-edit class="w-100 p-4" *ngIf="wizardState==='GeoCullEdit'" [isInSidebarContext]=true
                           [cullId]="campaignData?.geoCull?.id" [type]="'GeoCull'"
                           (submitSuccess)="filterSubmitSuccess($event)">
              </filter-edit>

              <sb-page-filter-list class="w-100 p-4" [isInIntegratedContext]="true"
                                   *ngIf="wizardState==='GeoCullSelect'" [preselectedCompany]="customer"
                                   preselectType="GeoCull"
                                   (selectedFilter)="selectFilter($event)"></sb-page-filter-list>
            </div>

            <div *ngIf="wizardState==='Map'">
              <sb-targeting-preview [isCollapsed]="true" [wizardPreviewState]="wizardPreviewState"
                                    (changeWizardState)="changeWizardPreviewState($event)"
                                    [campaignPreviewData]="previewCampaignData">
              </sb-targeting-preview>
              <sb-comp-cluster-map *ngIf="wizardPreviewState==='locationMap'" [mapHeight]="860"
                                   style="width: 100%;display: block;"
                                   [clusters]="clusters"
                                   (minMaxPointsChange)="refreshMap($event)"></sb-comp-cluster-map>
              <div *ngIf="wizardPreviewState==='locationList'" class="w-100 p-4" style="padding-top: 7rem!important;">
                <sb-page-inventory-wrapper [isInIntegratedContext]="true" [playerCull]="campaignData?.playerCull"
                                           [geoCull]="campaignData?.geoCull"></sb-page-inventory-wrapper>
              </div>
            </div>
          </div>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
